import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ConversationAmphoraOriginResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationAmphoraOriginResponseDataSchema>>
type Options = {
  enabled?: boolean
}

const getConversationAmphoraOriginQueryKey = (id: string) => ["conversations", id, "amphoraOrigin"]

export const conversationAmphoraOriginQuery = (id: string, options: Options = {}) => {
  return queryOptions({
    queryKey: getConversationAmphoraOriginQueryKey(id),
    queryFn: async () => {
      const response = await axios.get<Response>(`/conversations/${id}/amphora-origin`)
      return response.data.data
    },
    enabled: options.enabled,
  })
}
